export const JMC_COLORS = {
  primary: '#0C4DA2',  // Standardized brand blue
  primaryDark: '#07254C',  // Darker variant for text/accents
  secondary: '#E2272D',
  success: '#4CAF50',
  warning: '#FF9800',
  error: '#F44336',
  info: '#2196F3',
  background: '#F8FAFC',
  surface: '#FFFFFF',
  text: {
    primary: '#1A202C',
    secondary: '#4A5568',
    disabled: '#A0AEC0',
  },
  dark: {
    background: '#1a1a1a',
    surface: '#2c2c2c',
    text: {
      primary: '#E2E8F0',
      secondary: '#A0AEC0',
      disabled: '#718096',
    },
  },

  chemicals: '#0C4DA2',
  gas: '#43a047',
  power: '#e53935',
  water: '#1e88e5',
  steam: '#00BFFF',
  raw_material: '#6d4c41',
  time: '#8e24aa',
  production: '#3949ab',
  miscellaneous: '#00897b',
  dispatch: '#fb8c00',
};
